module.exports = __webpack_public_path__ + "static/media/Tooth_icon_0fbb58.5f3e1d9e.svg";